var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"guest-info-wrapper mb-0"},[_c('span',{staticClass:"guests-count"},[_vm._v(_vm._s(_vm.getGuestCount))])]),_c('p',{staticClass:"date-range mb-0"},[_vm._v(_vm._s(_vm.dateRange))])])
}
var staticRenderFns = []

export { render, staticRenderFns }